import {
    Card,
    Grid,
    ListSubheader,
    MenuItem,
    Select,
    TextField,
    Typography,
    Button,
    RadioGroup,
    FormControlLabel,
    Radio,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    FormControl
  } from '@mui/material';
  import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react';
  import { useForm } from 'react-hook-form';
  import moment from 'moment';
  import { DateRangePicker } from 'react-bootstrap-daterangepicker';
  import 'bootstrap-daterangepicker/daterangepicker.css';
  import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
  import { withStyles } from '@mui/styles';
  import { InputAdornment } from '@material-ui/core';
  import SearchIcon from '@mui/icons-material/Search';
  import {
    getAllEmployeeNameList,
    getEmployeeById,
    getReporterByEmpId
  } from 'src/services/employeeService';
  import { EmployeeInformation } from 'src/models/employee';
  import { useDispatch, useSelector } from 'react-redux';
  import { AppActions } from 'src/store/AppReducer';
  import { RootStateType } from 'src/store/RootReducer';
  import { getSingleProjectAllocationDetails } from 'src/services/projectService';
  import { ApplyLeave } from 'src/models/leave';
  import {
    applyLeave,
    applyWfh,
    getDayCount,
    getLeaveTypeList
  } from 'src/services/leaveService';
  import ConfirmationModal from '../common/confirmationModal/ConfirmationModal';
  import { useAppSelector } from 'src/hooks/hooks';
  import { TableHeaderCell } from 'src/components/TableHeaderCell';
  import { TableColumnCell } from 'src/components/TableColumnCell';
  import TotalLeaves from './TotalLeaves';
  import { useNavigate } from 'react-router';
  import SnackBar from 'src/components/SnackBar/SnackBar';
  import { DatePicker } from '@mui/lab';
import { getAllDefineLeaves } from 'src/services/DefineLeaveService';
  
  export interface LeaveInformation {
    name: string;
    designation: string;
    email: string;
    contact: string;
    segment: string;
    customer: string;
    HrApproval: string;
  }
  
  export interface LeaveTypes {
    id: string;
    employeeType: string;
    leaveType: string;
    gender: string;
    leaveNoDays: string;
    renewPeriod: string;
    hrApproval: string;
  }
  
  export interface ReporterDetails {
    employeeId: string;
    level: string;
    name: string;
  }
  
  const WorkFromHome: React.FC = () => {
    const appUser = useSelector((state: RootStateType) => state.appReducer.user);
    const employeeType = useSelector((state: RootStateType) => state.leaveManagementReducer?.userDetails?.employmentType);
    const myRef = useRef<DateRangePicker>();
    const [dateType, setDateType] = useState('full');
    const [tempDateType, setTempDateType] = useState('full');
    const [halfDayType, setHalfDayType] = useState('morning');
  
    const [startDate, setStartDate] = useState<any>('');
    const [endDate, setEndDate] = useState<any>('');
    const [dateChanged, setDateChanged] = useState(false);
    let [fileName, setFileName] = useState<any>('No File Selected');
    const [dayCount, setDayCount] = useState<any>('');
  
    var leaveList: LeaveTypes[] = [];
    var [leave, setLeave] = useState<any>(leaveList);
    const [resource, setResource] = useState<any>();

  
    var initialData: ReporterDetails[] = [];
    const [reporter, setReporter] = useState<any>(initialData);
  
    const [halfDayTypeError, setHalfDayTypeError] = useState('');
    const [daysCountError, setDaysCountError] = useState('');
    const [leaveReasonError, setLeaveReasonError] = useState('');
    const [toDateError, setToDateError] = useState('');
    const [reportingManagerError, setReportingManagerError] = useState('');
    const [halfDate, setHalfDate] = useState('');
  
    const [leaveType, setLeaveType] = useState<any>('');

    const [wfhID,setWfhIS]=useState<any>('');
    const [selectedLeaveType, setSelectedLeaveType] = useState<any>('');
    const [employmentType, setEmploymentType] = useState<string>('');
  
    const [attachmentError, setAttachmentError] = useState<string>('');
    const [attachment, setAttachment] = useState<any>({});
    const [leaveReasonLength, setLeaveReasonLength] = useState(0);
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState('');
    const [snackBarMessage, setSnackBarMessage] = useState('');
    const [isLeaveSummary, setIsLeaveSummary] = useState<boolean>(false);
    const [isDisabledRMPendingBtn, setIsDisabledRMPendingBtn] =
      useState<boolean>(false);
    const [breadcrumbs, setBreadcrumbs] = useState<boolean>(false);
    const [isDisabledEmployeeLeavesBtn, setIsDisabledEmployeeLeavesBtn] = useState<boolean>(false);
    const [mainProjectManager, setMainProjectManager] = useState<any>('');

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const currentDate = new Date();
  
    const handleDateTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setDateType((event.target as HTMLInputElement).value);
      if (dateType !== 'half') {
        setValue('dateType', false);
        setTempDateType('half');
      } else {
        setValue('dateType', true);
        setTempDateType('full');
      }
      setValue('halfDayType', null);
      setValue('daysCount', 0);
    };
  
    const handleHalfDayTypeChange = (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      setHalfDayType((event.target as HTMLInputElement).value);
      if ((event.target as HTMLInputElement).value === 'morning') {
        setValue('halfDayType', true);
      } else {
        setValue('halfDayType', false);
      }
  
      setHalfDayTypeError('');
    };
  
    const employeeId = useSelector(
      (state: RootStateType) => state.appReducer.user.EmployeeId
    );
    const isReportingManager = useSelector(
      (state: RootStateType) => state.leaveManagementReducer.isReportingManager
    );
  
    const { isLoading } = useAppSelector((state) => state.appReducer);
  
    const [openConfirmation, setOpenConfirmation] = useState(false);
  
    const { register, handleSubmit, reset, setValue, getValues } =
      useForm<ApplyLeave>();
  
    const validateiSFullDay = (data: ApplyLeave) => {
      if (data.dateType) {
        return data.fromDate !== '' && data.toDate !== '' ? true : false;
      } else {
        return data.toDate === '' || data.toDate === 'Invalid date'
          ? false
          : true;
      }
    };
  
    useEffect(() => {
      const user = window.localStorage.getItem('user');
      const userModel = JSON.parse(user);
      const selectedUserRole = userModel?.Roles;

      const user_role = selectedUserRole.split(',')
  
      if (
        user_role.includes('Super User') ||
        user_role.includes('HR Manager') ||
        user_role.includes('Assistant HR Manager') ||
        user_role.includes('HR Executive')
      ) {
        setIsDisabledRMPendingBtn(true);
        setBreadcrumbs(false);
        setIsDisabledEmployeeLeavesBtn(true);
      } else if (isReportingManager) {
        setIsDisabledRMPendingBtn(false);
        setBreadcrumbs(false);
        setIsDisabledEmployeeLeavesBtn(true);
      } else {
        setIsDisabledRMPendingBtn(false);
        setBreadcrumbs(true);
        setIsDisabledEmployeeLeavesBtn(false);
      }
    }, []);
  

    const isFullOrHalfDay = (data: ApplyLeave) => {
      if (dateType === 'half') {
        return data.halfDayType !== null ? true : false;
      } else {
        return true;
      }
    };
  
    const validateDayCount = (data: ApplyLeave) => {
      if (data.dateType || tempDateType === 'full') {
        if (data.daysCount === 0 || data.daysCount === undefined) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    };
  
    const validateRequiredField = () => {
      var data = getValues();
      setHalfDayTypeError('');
      setDaysCountError('');
      setLeaveReasonError('');
      setToDateError('');
      setReportingManagerError('');
        data.leaveTypeId =wfhID;
      if (data.fromDate === '' && data.toDate === '') {
        setValue('fromDate', startDate);
        setValue('toDate', endDate);
        data.fromDate = startDate;
        data.toDate = endDate;
      }
      if (data.fromDate === undefined) {
        data.fromDate = '';
      }
  
      if (data.toDate === undefined) {
        data.toDate = '';
      }
  
      if (
        isFullOrHalfDay(data) &&
        validateiSFullDay(data) &&
        validateDayCount(data) &&
        data.leaveReason !== '' &&
        data.leaveReason?.length < 501 &&
        data.reportingManagerId !== '' 

      ) {
        setOpenConfirmation(!openConfirmation);
      } else {
        if (dateType === 'half' && data.halfDayType === null) {
          setHalfDayTypeError('HalfDay type is required');
        }
        if (
          (data.dateType || dateType === 'full') &&
          data.fromDate === '' &&
          (data.toDate === '' || data.toDate === 'Invalid date')
        ) {
          setToDateError('Date range required');
        }
        if (
          !data.dateType &&
          (data.toDate === '' || data.toDate === 'Invalid date')
        ) {
          setToDateError('Date is required');
        }
        if (data.leaveReason === '') {
          setLeaveReasonError('Reason is required');
        }
        if (dateType === 'full' && dayCount === '') {
          setDaysCountError('Day count required');
        }
        if (data.reportingManagerId === '') {
          setReportingManagerError('Reporting manager is required');
        }
      }
    };
  
    const onSubmit = () => {
      dispatch(AppActions.showLoader());
      setValue('employeeId', employeeId);

      //base on project manager
      setValue('reportingManagerId', mainProjectManager?.projectManagerId ? mainProjectManager.projectManagerId : reporter?.employeeId);
      setValue('defaultReportingManagerId', reporter?.employeeId);

      if (dateType === 'full') {
        setValue('dateType', true);
      } else {

        setValue('dateType', false);
        setValue('daysCount', 0.5);
    }
      setValue('status', 'PENDING');
      const data = getValues();
      data.leaveTypeId =wfhID
      if (
        dateType === 'full' &&
        data.fromDate === 'Invalid date' &&
        data.toDate === 'Invalid date'
      ) {
        data.fromDate = startDate;
        data.toDate = endDate;
      }
      data.attachmentName = fileName !== 'No File Selected' ? fileName : '';
      const formData = new FormData();
      if (Object.keys(attachment).length !== 0) {
        formData.append('attachment', attachment.file);
      }
      formData.append('request', JSON.stringify(data));
  
      applyWfh(formData, employmentType?.toUpperCase())
        .then((res) => {
          if (res.data.statusCode === 200) {
            dispatch(AppActions.hideLoader());
            setSnackBarMessage(
              `Your Work From Home request has been sent to the ${mainProjectManager?.projectManagerId ? 'project' : 'reporting'} manager successfully.`
            );
            setSnackbarSeverity('success');
            setSnackBarOpen(true);
            setOpenConfirmation(false);
            onReset();
            setIsLeaveSummary(true);
            setTimeout(() => {
              setIsLeaveSummary(false);
            }, 5);
          }
        })
        .catch((err) => {
          dispatch(AppActions.hideLoader());
          setSnackBarMessage(
            err?.response?.data?.message
              ? err.response.data.message
              : 'Unable to request Work From Home'
          );
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          setOpenConfirmation(false);
        });
    };
  
    const onReset = () => {
      setLeaveType(wfhID);
      setDateChanged(false);
      setDateType('full');
      setTempDateType('full');
      setDayCount('');

      handleReset();
      setHalfDate('');
      setFileName('No File Selected');
      setLeaveReasonLength(0);

      setHalfDayTypeError('');
      setDaysCountError('');
      setLeaveReasonError('');

      setToDateError('');
      setReportingManagerError('');
      setAttachmentError('');
      setSelectedLeaveType('');
  
      reset();
    };
  
    const employeeDetails = () => {
      getEmployeeById(employeeId)
        .then((res) => {
          const gender = res.data?.gender;
          const type = res.data?.employeeFinance?.type;
          setEmploymentType(res.data?.employeeFinance?.type);
          getAllLeaveTypes(gender, type);
          
        })
        .catch(() => {});
    };
  
    const getAllLeaveTypes = (gender, employeeType) => {
      dispatch(AppActions.showLoader());
      getAllDefineLeaves()
        .then((res) => {
          setLeave(res.data.data.reverse());
          const workFromHomeId = res.data.data.find(item =>
            item.typeName === "Work From Home" && item.employmentType === employeeType.toUpperCase()
          );
          setLeaveType(workFromHomeId.id)
          setWfhIS(workFromHomeId.id)
          dispatch(AppActions.hideLoader());
        })
        .catch(() => {
          dispatch(AppActions.hideLoader());
        });
    };
  
    const getReporter = (empId) => {
      dispatch(AppActions.showLoader());
      getReporterByEmpId(empId).then((res) => {
        res.data.map((item, index) => {
          if (index === 0) {
            setReporter(item);
            setValue('reportingManagerId', item.employeeId);
          }
        });
        dispatch(AppActions.hideLoader());
      });
    };
  
    const getLeaveCount = (startDate, endDate) => {
      setDayCount('');
      setValue('daysCount', 0);
      getDayCount(startDate, endDate)
        .then((res) => {
          setDayCount(res.data.data);
          setValue('daysCount', res.data.data);
        })
        .catch((e) => {
          dispatch(AppActions.hideLoader());
          setSnackBarMessage(e.response?.data?.message);
          setSnackbarSeverity('Warning');
          setSnackBarOpen(true);
          setStartDate('');
          setEndDate('');
          setHalfDate('');
          setValue('fromDate', '');
          setValue('toDate', '');
          setDateChanged(false);
        });
    };
  
    const changeHandler = (event) => {
      if (event?.target) {
        const fileSize = (event.target.files[0]?.size / 1024 / 1024).toFixed(4);
        setFileName(event.target.files[0]?.name);
        const attachmentName = event.target.files[0]?.name;
  
        const extensionsRegex = /(\.pdf|\.doc|\.docx|\.png|\.jpeg|\.jpg)$/i;
  
        if (!extensionsRegex.exec(attachmentName)) {
          setFileName('No File Selected');
          setAttachmentError('File format is incorrect.');
        } else if (Number(fileSize) > 10) {
          setFileName('No File Selected');
          setAttachmentError('Please upload a file less than 10MB.');
        } else {
          setAttachmentError('');
          setAttachment({ file: event.target.files[0] });
        }
      }
    };
  
    const getInitSettings = () => {
      const today = new Date();
      let settings = {
        startDate: moment(today).format('MM/DD/YYYY'),
        endDate: moment(today).format('MM/DD/YYYY'),
      };
      return settings;
    };
  
    useEffect(() => {
      dispatch(AppActions.showLoader());
      if (startDate && endDate) {
        myRef.current.setStartDate(moment().subtract(1, 'months').date(1));
        myRef.current.setEndDate(moment());
      }
      setValue('fromDate', startDate);
      setValue('toDate', endDate);
      setValue('dateType', true);
      employeeDetails();
      getReporter(employeeId);
    }, []);
  
    const arrangeDate = (start: Date, end: Date) => {
      setDateChanged(true);
      const sDate = moment(start);
      const eDate = moment(end);
      setStartDate(sDate.format('DD/MM/YYYY'));
      setEndDate(eDate.format('DD/MM/YYYY'));
    };
  
    const applyCurrentDate = async (event, picker) => {
      if (!startDate && !endDate) {
        setDateChanged(true);
        const sDate = moment(picker.startDate);
        const eDate = moment(picker.endDate);
        setValue('fromDate', sDate.format('DD/MM/YYYY'));
        setValue('toDate', eDate.format('DD/MM/YYYY'));
        setStartDate(sDate.format('DD/MM/YYYY'));
        setEndDate(eDate.format('DD/MM/YYYY'));
      }
    };
  
  
    const handleReset = () => {
      const today = new Date();
      myRef.current?.setStartDate(moment(today).format('MM/DD/YYYY'));
      myRef.current?.setEndDate(moment(today).format('MM/DD/YYYY'));
      setStartDate('');
      setEndDate('');
      setDayCount('');
      setDateChanged(false);
    };
  
    const CustomTableRow = withStyles({
      root: {
        background: '#E6E9FF !important',
        height: '3.5rem'
      }
    })(TableRow);
  
    const containsText = (text, searchText) =>
      text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
  
    const [searchText, setSearchText] = useState('');
  
    const leaveTypes = useMemo(
      () =>
        leave?.length > 0 &&
        leave?.filter((option) => containsText(option.typeName, searchText)),
      [searchText, leave]
    );
  


    const handleWeekend = (value) => {
      if (value) {
        const date = new Date(value);
        const day = date.getUTCDay();
        return day === 0 || day === 6;
      } else {
        return false;
      }
    };
  
    const TextFieldStyle = {
      paddingTop: 4,
      paddingLeft: 15,
      paddingRight: 15,
      fontSize: '13px'
    };
  
    const dateStyle = {
      paddingTop: 4,
      paddingLeft: 15,
      fontSize: '13px'
    };
  
    const LabelStyle = {
      paddingLeft: 15,
      paddingRight: 15,
      fontSize: '13px'
    };
  
    const selectStyle = {
      width: '94%',
      marginLeft: 15,
      marginTop: 5,
      paddingRight: 15,
      fontSize: '13px'
    };
  
    const errorStyle = {
      paddingLeft: 15,
      paddingRight: 15,
      fontSize: '11px',
      color: 'red'
    };
  
    const getProjectAllocationDetails = (startDate, endDate) => {
      const body = {
        employeeId: employeeId,
        filter: {
          startDate: startDate,
          endDate: endDate
        }
      };
      if (startDate && endDate) {
        dispatch(AppActions.showLoader());
        getSingleProjectAllocationDetails(body).then((res) => {
          setResource(res.data);
          projectManagerHandling(res.data);
          dispatch(AppActions.hideLoader());
        }, (err) => {
          dispatch(AppActions.hideLoader());
        });
      }
    };
  
    const projectManagerHandling = (resourceRes: any) => {
      if(resourceRes?.allocations?.length > 0) {
        let selectedProjectManager = null;
  
        resourceRes.allocations.forEach((element: any) => {
          if(element.projectManagerId !== appUser.EmployeeId) {
            if(element.type === 'Billable') {
              if(selectedProjectManager === null || selectedProjectManager.type !== 'Billable') {
                selectedProjectManager = element;
              }else if(element.allocation > selectedProjectManager.allocation) {
                selectedProjectManager = element;
              }
            }else{
              if(selectedProjectManager === null) {
                selectedProjectManager = element;
              }else if(element.allocation > selectedProjectManager.allocation) {
                selectedProjectManager = element;
              }
            }
          }
        });
        setMainProjectManager(selectedProjectManager);
      }else{
        setMainProjectManager(null);
      }
    }

    const validateProjectManager = (projectManagerId: string) => {
      if(projectManagerId) {
        if(projectManagerId === mainProjectManager?.projectManagerId) {
          return '#FFC300';
        }
      }
    }
  
    return (
      <Grid sx={{ mx: 3 }}>
        <Grid container sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
          <Grid item>
            <Typography
              style={{
                marginLeft: '0px',
                fontWeight: '700',
                fontSize: '16px',
                fontFamily:
                  'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
              }}
            >
              {!breadcrumbs && (
                <span
                  style={{
                    cursor: 'pointer',
                    marginRight: '3px'
                  }}
                  onClick={() => {
                    navigate('/leave-management');
                  }}
                >
                  Leave Management
                </span>
              )}
              {!breadcrumbs && (
                <span
                  style={{
                    fontSize: '14px',
                    fontWeight: '550',
                    color: '#223354'
                  }}
                >
                  / Apply
                </span>
              )}
              {breadcrumbs && (
                <span
                  style={{
                    marginRight: '3px'
                  }}
                >
                  Leaves
                </span>
              )}
            </Typography>
            <Typography variant="subtitle2"></Typography>
          </Grid>
          <Grid item>
            <Button
             sx={{
              mr: 2,
              mt: { xs: 2, md: 0 },
              fontSize: '11px',
              fontWeight: 'normal'
              }}
              variant="contained"
              style={{ height: '1.75rem' }}
              onClick={(e) => {
                navigate(`/leave-management/apply-leave`);
              }}
            >
              Apply Leave
            </Button>
            {employeeType === 'Permanent' && (
              <Button
                sx={{
                  mr: 2,
                  mt: { xs: 2, md: 0 },
                  fontSize: '11px',
                  fontWeight: 'normal'
                }}
                variant="contained"
                style={{ height: '1.75rem' }}
                onClick={(e) => {
                  navigate(`/leave-management/apply-lieu-leave`);
                }}
              >
                Lieu Leave Eligibility
              </Button>
            )}
            {isDisabledRMPendingBtn && (
              <Button
                sx={{
                  mr: 2,
                  mt: { xs: 2, md: 0 },
                  fontSize: '11px',
                  fontWeight: 'normal'
                }}
                variant="contained"
                style={{ height: '1.75rem' }}
                onClick={(e) => {
                  navigate(`/leave-management/RM-pending-requests`);
                }}
              >
                PM/RM Pending Requests
              </Button>
            )}
            {isDisabledEmployeeLeavesBtn && (
              <Button
                sx={{
                  mr: 2,
                  mt: { xs: 2, md: 0 },
                  fontSize: '11px',
                  fontWeight: 'normal'
                }}
                variant="contained"
                style={{ height: '1.75rem' }}
                onClick={(e) => {
                  navigate(`/leave-management/employee-leaves`);
                }}
              >
                Employee Leaves
              </Button>
            )}
            <Button
              sx={{
                mt: { xs: 2, md: 0 },
                fontSize: '11px',
                fontWeight: 'normal'
              }}
              variant="contained"
              style={{ height: '1.75rem' }}
              onClick={(e) => {
                navigate(`/leave-management/my-leave-history/id`);
              }}
            >
              My Leave History
            </Button>
          </Grid>
        </Grid>
        <Grid container sx={{ mt: 1, mb: 1, px: 0, mx: 0, pl: 0 }}>
          <Grid xs={8}>
            <Card style={{ padding: '1rem' }}>
              <Grid item style={{ paddingBottom: '1rem' }}>
                <Typography
                  style={{ fontSize: '12px', paddingLeft: '15px' }}
                  variant="h3"
                >
                  Apply Work From Home
                </Typography>
              </Grid>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2} sx={{ paddingBottom: '1rem' }}>
                  <Grid item xs={6}>
                    <Typography
                      style={LabelStyle}
                      fontWeight="light"
                      variant="h5"
                    >
                      Leave Type<span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <Select
                      className="select-text"
                      size="small"
                      style={selectStyle}
                      displayEmpty
                      inputProps={{ 'aria-label': 'Without label' }}
                      defaultValue={256}
                      value={leaveType || ''}
                      {...register('leaveTypeId', {
                        valueAsNumber: true
                      })}
                      disabled
                    >
                      <MenuItem
                        style={{ display: 'none' }}
                        selected
                        disabled
                        value={''}
                      >
                       Select Leave Type
                      </MenuItem>
                      
                      {leaveTypes?.length > 0 &&
                        leaveTypes.map((element) => (
                          <MenuItem key={element.id} value={element.id}>
                            {element.typeName}
                          </MenuItem>
                        ))}
                    </Select>
                  </Grid>
                  {selectedLeaveType !== 'SHORT LEAVE' && (
                  <Grid item xs={6}>
                    <Typography
                      style={LabelStyle}
                      fontWeight="light"
                      variant="h5"
                    >
                      Day Type<span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <RadioGroup
                      className="radioBtn"
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="dateTypeGroup"
                      sx={{ paddingLeft: '15px' }}
                      value={dateType}
                      onChange={handleDateTypeChange}
                    >
                      <FormControlLabel
                        value="full"
                        control={<Radio />}
                        label="Full Day"
                      />
                      <FormControlLabel
                        value="half"
                        control={<Radio />}
                        label="Half Day"
                      />
                    </RadioGroup>
                    <Typography style={errorStyle}></Typography>
                  </Grid>
                  )}
                  {(dateType === 'full')  ? (
                    <Fragment>
                      <Grid className="date-range" item xs={6}>
                        <Typography
                          style={LabelStyle}
                          fontWeight="light"
                          variant="h5"
                        >
                          Date(s)<span style={{ color: 'red' }}>*</span>
                        </Typography>
                        <DateRangePicker
                          ref={myRef}
                          initialSettings={getInitSettings()}
                          onCallback={(start, end) => arrangeDate(start, end)}
                          onApply={(event, picker) => {
                            applyCurrentDate(event, picker).then(() => {
                              setValue('fromDate', startDate);
                              setValue('toDate', endDate);
                              getLeaveCount(
                                moment(picker.startDate).format('DD/MM/YYYY'),
                                moment(picker.endDate).format('DD/MM/YYYY')
                              );
                              getProjectAllocationDetails(
                                moment(picker.startDate).format('YYYY-MM-DD'),
                                moment(picker.endDate).format('YYYY-MM-DD')
                              );
                              setToDateError('');
                              setDaysCountError('');
                            });
                          }}
                          onCancel={() => {
                            handleReset();
                          }}
                        >
                          <div style={{ position: 'relative' }}>
                            <TextField
                              placeholder="DD/MM/YYYY - DD/MM/YYYY"
                              value={
                                dateChanged
                                  ? (startDate && startDate) +
                                    ' - ' +
                                    (endDate && endDate)
                                  : ''
                              }
                              id="date"
                              fullWidth
                              size="small"
                              style={dateStyle}
                            />
                            <CalendarTodayIcon
                              className="calendar-icon"
                              fontSize={'small'}
                            />
                          </div>
                        </DateRangePicker>
                        <Typography style={errorStyle}>{toDateError}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          style={LabelStyle}
                          fontWeight="light"
                          variant="h5"
                        >
                          Days Count<span style={{ color: 'red' }}>*</span>
                        </Typography>
                        <TextField
                          inputProps={{ maxLength: 30 }}
                          size="small"
                          style={TextFieldStyle}
                          fullWidth
                          placeholder="Enter Days Count"
                          variant="outlined"
                          value={dayCount}
                          disabled
                          defaultValue={''}
                          {...register('daysCount')}
                          onChange={() => {
                            setDaysCountError('');
                          }}
                        />
                        <Typography style={errorStyle}>
                          {daysCountError}
                        </Typography>
                      </Grid>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <Grid item xs={6}>
                        <Typography
                          style={LabelStyle}
                          fontWeight="light"
                          variant="h5"
                        >
                          Half Day Type<span style={{ color: 'red' }}>*</span>
                        </Typography>
                        <RadioGroup
                          className="radioBtn"
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          sx={{ paddingLeft: '15px' }}
                          onChange={handleHalfDayTypeChange}
                        >
                          <FormControlLabel
                            value="morning"
                            control={<Radio />}
                            label="Morning"
                          />
                          <FormControlLabel
                            value="evening"
                            control={<Radio />}
                            label="Evening"
                          />
                        </RadioGroup>
                        <Typography style={errorStyle}>
                          {halfDayTypeError}
                        </Typography>
                      </Grid>
                    {/* //   )} */}
                      <Grid item xs={6}>
                        <Typography
                          style={LabelStyle}
                          fontWeight="light"
                          variant="h5"
                        >
                          Date<span style={{ color: 'red' }}>*</span>
                        </Typography>
                        <div style={{ marginLeft: 15, marginRight: 15 }}>
                          <FormControl fullWidth>
                            <DatePicker
                              InputProps={{
                                className: 'date-picker'
                              }}
                              renderInput={(params) => (
                                <TextField {...params} id="date" />
                              )}
                              value={halfDate ? halfDate : ''}
                              onChange={(newValue) => {
                                if (newValue) {
                                  setHalfDate(moment(newValue).format('YYYY-MM-DD'));
                                  // handleShortLeave();
                                  if (handleWeekend(moment(newValue).format('YYYY-MM-DD'),)) {
                                    setHalfDate('');
                                    setValue('fromDate', '');
                                  }
                                  setValue('fromDate', moment(newValue).format('DD/MM/YYYY'));
                                  setValue('toDate', moment(newValue).format('DD/MM/YYYY'));
                                  setToDateError('');
                                  getProjectAllocationDetails(
                                    moment(newValue).format('YYYY-MM-DD'),
                                    moment(newValue).format('YYYY-MM-DD')
                                  );
                                  getLeaveCount(
                                    moment(newValue).format('DD/MM/YYYY'),
                                    moment(newValue).format('DD/MM/YYYY')
                                  );
                                }
                              }}
                            />
                          </FormControl>
                        </div>
                        <Typography style={errorStyle}>{toDateError}</Typography>
                      </Grid>
                      
                    </Fragment>
                  )}
                  <Grid item xs={12}>
                    <Typography
                      style={LabelStyle}
                      fontWeight="light"
                      variant="h5"
                    >
                      Reason<span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      size="small"
                      multiline
                      rows={3}
                      className="input-text"
                      style={TextFieldStyle}
                      inputProps={{
                        style: {
                          fontSize: '13px'
                        },
                        maxLength: 500
                      }}
                      fullWidth
                      placeholder="Enter Reason"
                      variant="outlined"
                      {...register('leaveReason')}
                      onChange={(e) => {
                        setLeaveReasonLength(e.target.value.length);
                        setLeaveReasonError('');
                      }}
                    />
                    <Typography style={errorStyle}>{leaveReasonError}</Typography>
                    <Typography
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        marginRight: '1rem',
                        fontSize: '12px',
                        marginTop: leaveReasonError ? '-1rem' :''
                      }}
                    >
                      {leaveReasonLength} / 500
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                  <Typography
                    style={LabelStyle}
                    fontWeight="light"
                    variant="h5"
                  >
                    Reporting Manager<span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <TextField
                    inputProps={{ maxLength: 30 }}
                    size="small"
                    style={dateStyle}
                    fullWidth
                    placeholder="Enter Reporting Manager"
                    variant="outlined"
                    disabled
                    value={reporter.name}
                    key={reporter.employeeId}
                    {...register('reportingManagerId')}
                  />
                  <Typography style={errorStyle}>
                    {reportingManagerError}
                  </Typography>
                </Grid>
                  <Fragment>
                    <Grid item xs={4}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                      >
                        Attachment
                      </Typography>
                      <TextField
                        style={TextFieldStyle}
                        InputProps={{
                          style: { fontSize: '12px', height: '2.25rem' }
                        }}
                        fullWidth
                        size="small"
                        disabled
                        value={fileName}
                      />
                      <p
                        style={{
                          marginLeft: '1.2rem',
                          marginTop: 0,
                          marginBottom: 0,
                          fontSize: '0.55rem',
                          height: '0rem'
                        }}
                      >
                        Maximum file upload size: 10MB
                      </p>
                      {attachmentError && (
                        <p
                          style={{
                            marginLeft: '1.2rem',
                            marginTop: '1rem',
                            marginBottom: 0,
                            fontSize: '11px',
                            height: '0rem',
                            color: 'red'
                          }}
                        >
                          {attachmentError}
                        </p>
                      )}
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      sx={{
                        paddingRight: '15px',
                        paddingLeft: '10px !important'
                      }}
                    >
                      <Button
                        style={{
                          marginTop: '1.3rem',
                          border: '1px solid #5569ff',
                          color: '#5569ff',
                          padding: '6px 8px',
                          borderRadius: '6px',
                          fontSize: '13px',
                          fontWeight: 'normal',
                          width: '100%'
                        }}
                      >
                        Choose
                        <input
                          type="file"
                          name="attachment"
                          id="upload-attachment"
                          accept=".pdf, .doc, .docx, .png, .jpeg, .jpg"
                          onChange={changeHandler}
                        />
                      </Button>
                    </Grid>
                  </Fragment>
                </Grid>
                {(startDate && endDate) || halfDate ? (
                  <>
                    <Grid
                      item
                      style={{ paddingBottom: '1rem', paddingTop: '2rem' }}
                    >
                    <div
                      style={{ paddingLeft: '15px', paddingRight: '15px', display: 'flex', justifyContent: 'space-between' }}
                    >
                      <Typography variant="h3" style={{ fontSize: '12px' }}>Project Allocation - Within The Leave Period</Typography>
                      <div style={{ display: 'flex', gap: '10px', alignItems: 'center'}}>
                        <div style={{
                          background: '#FFC300',
                          borderRadius: '50%',
                          width: '7px',
                          height: '7px'
                        }}></div>
                        <Typography variant="h3" style={{ fontSize: '12px' }}>Approver</Typography>
                      </div>
                    </div>
                    </Grid>
                    <TableContainer className="tableContainer">
                      <Table style={{ borderCollapse: 'separate' }} size="small">
                        <TableHead>
                          <CustomTableRow>
                            <TableHeaderCell content="Project Name" smallFont />
                            <TableHeaderCell content="Type" smallFont />
                            <TableHeaderCell content="Allocation" smallFont />
                            <TableHeaderCell content="Project Manager" smallFont />
                          </CustomTableRow>
                        </TableHead>
                        <TableBody>
                          {resource?.allocations.length > 0 ? (
                            <>
                              {resource?.allocations.map((item) => (
                                <TableRow hover>
                                  <TableColumnCell>
                                    <Typography
                                      paddingBottom="0.25rem"
                                      paddingTop="0.5rem"
                                      variant="body2"
                                      style={{ fontSize: '11px' }}
                                      gutterBottom
                                      noWrap
                                    >
                                      {item.projectName}
                                    </Typography>
                                  </TableColumnCell>
                                  <TableColumnCell>
                                    <Typography
                                      paddingBottom="0.25rem"
                                      paddingTop="0.5rem"
                                      variant="body2"
                                      style={{ fontSize: '11px' }}
                                      gutterBottom
                                      noWrap
                                    >
                                      {item.type}
                                    </Typography>
                                  </TableColumnCell>
                                  <TableColumnCell>
                                    <Typography
                                      paddingBottom="0.25rem"
                                      paddingTop="0.5rem"
                                      variant="body2"
                                      style={{ fontSize: '11px' }}
                                      color="text.primary"
                                      gutterBottom
                                      noWrap
                                    >
                                      {item.allocation}%
                                    </Typography>
                                  </TableColumnCell>
                                  <TableColumnCell>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
                                      <div style={{
                                        background: validateProjectManager(item?.projectManagerId),
                                        borderRadius: '50%',
                                        width: '7px',
                                        height: '7px'
                                      }}
                                      ></div>
                                      <Typography
                                        paddingBottom="0.25rem"
                                        paddingTop="0.5rem"
                                        variant="body2"
                                        color="text.primary"
                                        gutterBottom
                                        noWrap
                                        style={{fontSize: '11px'}}
                                      >
                                        {item?.projectManager ? item.projectManager : '-'}
                                      </Typography>
                                    </div>
                                  </TableColumnCell>
                                </TableRow>
                              ))}
                            </>
                          ) : (
                            <>
                              <TableRow>
                                <TableColumnCell />
                                <TableColumnCell>No record data</TableColumnCell>
                                <TableColumnCell />
                              </TableRow>
                            </>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                ) : (
                  <></>
                )}
                <Grid
                  item
                  sx={{
                    mt: 4,
                    pr: 2,
                    display: 'flex',
                    justifyContent: 'flex-end'
                  }}
                  xs={12}
                >
                  <Button
                    sx={{
                      width: '10%',
                      fontWeight: 'normal',
                      background: '#F5F7FF',
                      fontSize: '13px'
                    }}
                    onClick={onReset}
                  >
                    Reset
                  </Button>
                  <Button
                    sx={{
                      ml: 2,
                      width: '10%',
                      fontSize: '13px',
                      fontWeight: 'normal',
                      background: '#0069E4'
                    }}
                    variant="contained"
                    type="button"
                    disabled={isLoading}
                    onClick={() => validateRequiredField()}
                  >
                    Apply
                  </Button>
                </Grid>
                <ConfirmationModal
                  isLoading={isLoading}
                  open={openConfirmation}
                  toggle={validateRequiredField}
                  message={`Are you sure want to apply for this Work From Home Request?`}
                  onConfirm={() => onSubmit()}
                  noToggle={validateRequiredField}
                />
              </form>
            </Card>
            <SnackBar
              snackBarOpen={snackBarOpen}
              setSnackBarOpen={setSnackBarOpen}
              snackBarMessage={snackBarMessage}
              snackbarSeverity={snackbarSeverity}
            />
          </Grid>
          <Grid xs={4} style={{ paddingLeft: '1rem' }}>
            <TotalLeaves sendData={isLeaveSummary} />
          </Grid>
        </Grid>
      </Grid>
    );
  };
  
  export default WorkFromHome;
  